import React, { useState, useEffect ,useRef } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import Header from "../../component/Header/Header";
import Footer from "../../component/Footer/Footer";
import EditTextField from "../../component/EditTextfieldComponent/index";
import Sidebar from "../Sidebar/index";
import "./editcatelogue.scss";
import { useNavigate } from "react-router-dom";
import { safeDecode } from "../../common/decoder";
import { EditpartcatelogueAction } from "../../actions/partcatelogueAction";
import { VehicleCategoryAction } from "../../actions/partcatelogueAction";
import { getVehicleAction } from "../../actions/getVehicle";
import Loader from "../../component/loaderComponent/Loader";
import { updatecatalogueAction } from "../../actions/partcatelogueAction";
import { NotificationManager } from "react-notifications";
import { getVehiclelist_categoryAction } from "../../actions/getVehicle";
import DOMPurify from "dompurify";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { fileType } from "../../constants/filetype/filetype";
import { Modal } from "react-bootstrap";
import PopupConfirmation from "../../component/PopupConfirmation/PopupConfirmation";
import { hasPermission } from "../../utils/permissionUtils";
import { PERMISSIONS } from "../../constants/permissions/Permissions";

function EditCatelogue() {
  const { id } = useParams();
  const decodeid = safeDecode(id);
  const [state, setstate] = useState({
    catalogue_file: "",
    catalogue_image: "",
    vehicle_category: "",
    vehicle_name: "",
    vehicle_id:'',
    catalogue_file_name:""
  })
  const item="Edit"
  const [editpartcatelogueList, setEditpartCatelogueList] = useState([])
  const [isLoading, setIsLoading] = useState(false);
  const [isEdited, setIsEdited] = useState(false);
  const dispatch = useDispatch();
  const [getVehicleList, setGetVehicleList] = useState([])
  const { i18n, t } = useTranslation();
  const language = Cookies.get("language");


  async function VehicleListData() {
    let response = await dispatch(getVehicleAction());
    if (response == 200 || response != null) {
      setGetVehicleList(response.data.data.results);
    }
  }
  
  const [confirmationPopupShow, setConfirmationPopupshow] = useState(false);
  const handleConfirmationPopup = () => {
    setConfirmationPopupshow(true);
  };
  const handleEditCateloguePopupCloseButtons = () => {
      if (!isEdited || state.catalogue_image === null || Object.values(state).some((value) => value === "")) {
        navigate("/partcatelogue");
        return;
      }
      setConfirmationPopupshow(true)
  };
  const closePartCatelogueConfirmationPopup = () => {
    setConfirmationPopupshow(false);
    setIsEdited(false)
  };
  useEffect(() => {
    EditPartsCatelogueListData();
    VehicleCategoryListData();
    VehicleListData();
    handleChangeLanguage(language);
    // if (state.vehicle_category) {
    //   CategoryVehicleListData(state?.vehicle_category);
    // }
  }, []);
  const handleChangeLanguage = (language) => {
    i18n.changeLanguage(language);
  };

  // const [getVehiclecatList, setGetVehiclecatList] = useState([]);

  // async function CategoryVehicleListData(id) {
  //   setIsLoadings(true);
  //   let response = await dispatch(getVehiclelist_categoryAction(id));
  //   if (response == 200 || response != null) {
  //     setIsLoadings(false);
  //     setGetVehiclecatList(response.data.data.results);
  //   }
  // }
  async function EditPartsCatelogueListData() {
    setIsLoading(true);
    let response = await dispatch(EditpartcatelogueAction(decodeid));
    if (response == 200 || response != null) {
      setEditpartCatelogueList(response?.data?.data?.items);
      setstate({
        catalogue_file: response.data?.data?.catalogue_file,
        catalogue_image: response.data?.data?.catalogue_image,
        vehicle_category: response.data?.data?.vehicle_category,
        vehicle_name: response.data?.data?.vehicle_name,
        vehicle_id:response.data?.data?.vehicle,
        catalogue_file_name:response.data?.data?.catalogue_file_name
      })
      setIsLoading(false);
    }

    else if (response === undefined) {
      setIsLoading(false);
    }
  }

  const [vehicleList, setVehicleList] = useState([])
  const [isLoadings, setIsLoadings] = useState(false);

  async function VehicleCategoryListData() {
    setIsLoadings(true);
    let response = await dispatch(VehicleCategoryAction());
    if (response == 200 || response != null) {
      setIsLoadings(false);
      setVehicleList(response?.data?.data?.results);
    }
    else if (response === undefined) {
      setIsLoading(false);
    }
  }

  const navigate = useNavigate();
  const EditCatelogue = () => {
    navigate("/partcatelogue")
  }
  const fileInputRef = useRef(null);
  const fileInputRefs = useRef(null);

  const handleFileUploads = (event) => {
    const files = event.target.files[0];
    if (files) {
      const allowedPdfTypes = fileType.PDF.mimeType;
      if (allowedPdfTypes.includes(files.type)) {
        setcatalogue_file(files);
      } else {
        NotificationManager.error("Invalid file type. Please select an PDF file.")
        if (fileInputRefs.current) {
          fileInputRefs.current.value = null;
        }
      }
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedImageTypes = fileType.IMAGE;
      if (allowedImageTypes.includes(file.type)) {
        setSelectedImage(file);
      } else {
        NotificationManager.error(t('validationmsg.invalidimage'))
        if (fileInputRef.current) {
          fileInputRef.current.value = null;
        }
      }
    }
  };

  const handleChange = (evt) => {
    const { name,id, value } = evt.target;
    setstate({
      ...state,
      [id]: value.replace(/^ +/gm, ""),
    });
    setIsEdited(true);
  };

  const [selectedImage, setSelectedImage] = useState(null);
  const [catalogueEdit_file, setcatalogue_file] = useState(null);

  const onupdatecatlogue = async () => {
    setIsLoading(true);
    let apiReq = {
      vehicle: state.vehicle_id,
    };
    if(selectedImage){
      apiReq.catalogue_image=selectedImage;
    }
    if(catalogueEdit_file){
      apiReq.catalogue_file=catalogueEdit_file
    }
    let response = await dispatch(updatecatalogueAction(decodeid, apiReq));
    if (response == 200 || response != null) {
      setIsLoading(false);
      NotificationManager.success(response.data.message);
      navigate("/partcatelogue");
      window.scroll(0, 0);
    } else if (response === undefined) {
      setIsLoading(false);
    }
  };

  return (

    <div className="editcatelogue_containers">
      <div className="editcatelogue_container">
        <div className="editcateloguemain">
          <div className="header_border tvsparts_text">
            TVS &gt; {t('addcatalogues.editcatelogue')}
          </div>
          <div className="editcateloguebuttons_container">
            <span className="Addnew_text" >{t('addcatalogues.editnewpartcat')} </span>
            <button className="edit_catelogue_addbuttons" onClick={handleEditCateloguePopupCloseButtons}>{t('addparts.close')}</button>
          </div>
          {isLoading ? (<Loader />) : (
            <div>
              <div className="editcatelogue_second_para">
                {selectedImage ? (
                  <img
                    src={DOMPurify.sanitize(URL.createObjectURL(selectedImage))}
                    alt="Uploaded"
                    className="product-img"
                  />
                ) : (
                  <img src={state.catalogue_image ? state.catalogue_image : Image_Url.PARTCATELOGUE}  />
                )}
                {/* <img src={state.catalogue_image ? state.catalogue_image : Image_Url.PARTCATELOGUE} /> */}
                <label
                  className="select-lable-img required"
                  htmlFor="banner3"
                  onChange={handleImageChange}
                >
                  {t('addcatalogues.selectimage')}
                  <input
                    type="file"
                    name="banner3"
                    id="banner3"
                    hidden
                    ref={fileInputRef}
                    onChange={handleImageChange}
                    accept="image/*"
                  />
                </label>
              </div>
              <div className="editcatelogue_third_para">
                <EditTextField value={state} vehicleList={vehicleList} mode={item} getVehicleList={getVehicleList} catalogueEdit_file={catalogueEdit_file} handleFileUploads={handleFileUploads} handleChange={handleChange} />
              </div>
              <div className="third_para">
                {hasPermission(PERMISSIONS.CAN_UPDATE_PART_CATALOGUE) && (
                  <button className="edit_catelogue_addbuttons"
                    onClick={handleConfirmationPopup}
                    disabled={
                    state.catalogue_image === null ||
                    Object.values(state).some((value) => value === "")
                  }
                  > {t('editparts.update')} </button>
                )}
              </div>
            </div>
          )}

          <div className="footer_div">
            <Footer />
          </div>
        </div>
      </div>
      <Modal
        className="expertise-modal"
        show={confirmationPopupShow}
        onHide={closePartCatelogueConfirmationPopup}
      >
        <Modal.Body>
          {confirmationPopupShow && (
            <PopupConfirmation
              handleConfirmationPopupClose={closePartCatelogueConfirmationPopup}
              onSaveClick={onupdatecatlogue}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default EditCatelogue;
